/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Ai_HintInputs */

const cs_blog_ai_hint = /** @type {(inputs: Blog_Ai_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nejdřív pište nebo vylepšete jeden jazyk, pak přeložte do ostatních.`)
};

const en_blog_ai_hint = /** @type {(inputs: Blog_Ai_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draft or polish one language at a time, then translate to the rest.`)
};

/**
* | output |
* | --- |
* | "Draft or polish one language at a time, then translate to the rest." |
*
* @param {Blog_Ai_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_ai_hint = /** @type {((inputs?: Blog_Ai_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Ai_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_ai_hint(inputs)
	return cs_blog_ai_hint(inputs)
});